
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "delete-transactions-panel-header",
  components: {},
})
export class DeleteTransactionsPanelHeader extends Vue {}
export default DeleteTransactionsPanelHeader;
